(() => {
  if (customElements.get('sonnesee-product-combination')) return;

  class SonneseeProductCombination extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-combination-item]'));
      this.total = this.querySelector('[data-combination-total]');
      this.count = this.querySelector('[data-combination-count]');
      this.saving = this.querySelector('[data-combination-saving]');
      this.submit = this.querySelector('[data-combination-submit]');
      this.message = this.querySelector('[data-combination-message]');
      this.defaultButtonText = this.submit?.querySelector('span')?.textContent || '';
      this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      });

      this.items.forEach((item) => {
        item.querySelector('[data-combination-checkbox]')?.addEventListener('change', () => this.update());
        item.querySelector('select[data-combination-variant]')?.addEventListener('change', (event) => {
          this.updateVariant(item, event.currentTarget.selectedOptions[0]);
          this.update();
        });
      });
      this.submit?.addEventListener('click', () => this.addSelected());
      this.update();
    }

    formatMoney(cents) {
      return this.moneyFormatter.format(Number(cents || 0) / 100);
    }

    variantData(item) {
      const control = item.querySelector('[data-combination-variant]');
      const source = control?.tagName === 'SELECT' ? control.selectedOptions[0] : control;
      return {
        id: Number(control?.value || 0),
        price: Number(source?.dataset.price || 0),
        compareAt: Number(source?.dataset.compareAt || 0),
        available: source?.dataset.available === 'true'
      };
    }

    updateVariant(item, option) {
      const price = Number(option.dataset.price || 0);
      const compareAt = Number(option.dataset.compareAt || 0);
      const available = option.dataset.available === 'true';
      const checkbox = item.querySelector('[data-combination-checkbox]');
      const image = item.querySelector('[data-combination-image]');
      const priceElement = item.querySelector('[data-combination-price]');
      const compareElement = item.querySelector('[data-combination-compare]');

      if (priceElement) priceElement.textContent = this.formatMoney(price);
      if (compareElement) {
        compareElement.hidden = !(compareAt > price);
        compareElement.textContent = compareAt > price ? this.formatMoney(compareAt) : '';
      }
      if (image && option.dataset.image) image.src = option.dataset.image;
      if (checkbox) {
        checkbox.disabled = !available;
        if (!available) checkbox.checked = false;
      }
      item.classList.toggle('is-unavailable', !available);
    }

    update() {
      let total = 0;
      let savings = 0;
      let selectedCount = 0;

      this.items.forEach((item) => {
        const checkbox = item.querySelector('[data-combination-checkbox]');
        const variant = this.variantData(item);
        const selected = Boolean(checkbox?.checked && !checkbox.disabled && variant.available);
        item.classList.toggle('is-deselected', !selected);
        if (!selected) return;
        selectedCount += 1;
        total += variant.price;
        if (variant.compareAt > variant.price) savings += variant.compareAt - variant.price;
      });

      if (this.total) this.total.textContent = this.formatMoney(total);
      if (this.count) this.count.textContent = `(${selectedCount} ${selectedCount === 1 ? 'Produkt' : 'Produkte'})`;
      if (this.saving) {
        this.saving.hidden = savings <= 0;
        const savingValue = this.saving.querySelector('strong');
        if (savingValue) savingValue.textContent = this.formatMoney(savings);
      }
      if (this.submit) this.submit.disabled = selectedCount === 0;
      if (this.message) this.message.textContent = '';
    }

    async addSelected() {
      const items = this.items.flatMap((item) => {
        const checkbox = item.querySelector('[data-combination-checkbox]');
        const variant = this.variantData(item);
        return checkbox?.checked && !checkbox.disabled && variant.available && variant.id
          ? [{ id: variant.id, quantity: 1 }]
          : [];
      });
      if (!items.length || !this.submit) return;

      this.submit.disabled = true;
      this.submit.classList.add('is-loading');
      if (this.message) this.message.textContent = '';

      const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = typeof cartUi?.getSectionsToRender === 'function'
        ? cartUi.getSectionsToRender().map((section) => section.id)
        : [];
      const body = { items };
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Die Produkte konnten nicht hinzugefügt werden.');

        if (cartUi && typeof cartUi.renderContents === 'function' && result.sections) {
          cartUi.renderContents(result);
        } else {
          window.location.assign(this.dataset.cartUrl || '/cart');
          return;
        }

        const label = this.submit.querySelector('span');
        if (label) label.textContent = 'Produkte hinzugefügt';
        setTimeout(() => {
          if (label) label.textContent = this.defaultButtonText;
          this.submit.disabled = false;
        }, 1800);
      } catch (error) {
        if (this.message) this.message.textContent = error.message;
        this.submit.disabled = false;
      } finally {
        this.submit.classList.remove('is-loading');
      }
    }
  }

  customElements.define('sonnesee-product-combination', SonneseeProductCombination);
})();
